import { useState } from 'react'
import WorkOrderNotes from '../notes/WorkOrderNotes'
import ScheduleContainerModal from '../scheduling-modal/container-modal/ScheduleContainerModal'
import LineItemsTable from '../tables/line-items/LineItemsTable'
import OverviewSummaryTable from '../tables/overview-summary/OverviewSummaryTable'
import WorkOrderHistoryEntriesTable from '../tables/work-order-history-entries/WorkOrderHistoryEntriesTable'
import WorkOrderVehiclesTable from '../tables/work-order-vehicles/WorkOrderVehiclesTable'
import AdditionalActions from '../work-order-utility/AdditionalActions'
import styles from './styles.module.css'
import { MODES } from '../../../../../global/constants/scheduler'

interface IModalContentProps {
  selectedOrder?: string
}

export default function ModalContent({
  selectedOrder,
}: IModalContentProps) {

  //scheduler modal
  const [scheduleModalOpen, setScheduleModalOpen] = useState<boolean>(false)
  const [modalName, setModalName] = useState<string>('')

  //mode: controls the flow depending on the button clicked
  //e.g. if "finish" is clicked, the modal will navigate through the whole scheduling flow instead of closing after saving the customer info
  const [mode, setMode] = useState<string>('')

	function openOrderModal(modalName: string) {
		setModalName(modalName)
		setMode(MODES.EDIT)
		setScheduleModalOpen(true)
	}

  function closeOrderModal() {
    setScheduleModalOpen(false)
    setModalName('')
  }


  return (
    <>
      <div className={styles.pageTitle}>Work Order Details</div>
      <div className={styles.woDetailsContent}>
        <ScheduleContainerModal
          isOpen={scheduleModalOpen}
          handleClosed={closeOrderModal}
          route={modalName}
          mode={mode}
          setModalName={setModalName}
        />
        <div className={styles.tablesWrapper}>
          <OverviewSummaryTable
            openOrderModal={openOrderModal}
            modalName={modalName}
            closeOrderModal={closeOrderModal}
          />
          <WorkOrderVehiclesTable
            selectedOrder={selectedOrder}
            openOrderModal={openOrderModal}
          />
          <LineItemsTable
            selectedOrder={selectedOrder}
            openOrderModal={openOrderModal}
          />
          <WorkOrderHistoryEntriesTable
            selectedOrder={selectedOrder}
          />
        </div>
        <div className={styles.sideFlexWrapper}>
          <div className={styles.sideNotesContainer}>
            <WorkOrderNotes
              selectedOrder={selectedOrder}
            />
          </div>
          <div className={styles.sideAdditionalActionsContainer}>
            <AdditionalActions />
          </div>
        </div>
      </div>
    </>
  )
}
